import { styled, TableCell, tableCellClasses, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 'bold'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}))

const PaymentGraphicTableHead = () => {
  const { t } = useTranslation()

  const rows = [
    t('client.applicationForm.paymentGraphicTable.header.date'),
    t('client.applicationForm.paymentGraphicTable.header.principal'),
    t('client.applicationForm.paymentGraphicTable.header.interest'),
    t('client.applicationForm.paymentGraphicTable.header.commission'),
    t('client.applicationForm.paymentGraphicTable.header.total')
  ]

  return (
    <TableHead>
      <TableRow>
        {rows.map(row => (
          <StyledTableCell key={row}>
            {row}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default PaymentGraphicTableHead
